<template>
  <div class="error-notifier__wrapper" :style="wrapperDynamicStyle">
    <transition-group name="list-complete" tag="p">
      <error-handler-message
        v-for="error in errorMessages"
        :key="error.id"
        v-bind="error"
        class="error-notifier__message"
      />
    </transition-group>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ErrorHandlerMessage from './ErrorHandlerMessage'
import { hydrationHelpers } from '@/utils/mixins/hydrationHelpers'

export default {
  name: 'AEventNotifier',
  mixins: [hydrationHelpers],
  components: { ErrorHandlerMessage },
  computed: {
    ...mapGetters({
      errorMessages: 'errors/errorMessages'
    }),
    wrapperDynamicStyle() {
      return {
        top: `${this.$_hydrationHelpers_menuHeight}px`
      }
    }
  },
  mounted() {
    window.onerror = (msg, url, line, col, error) => {
      this.$errorHandler(error, null, { message: msg })
    }
  }
}
</script>

<style lang="scss" scoped>
.error-notifier__wrapper {
  position: fixed;
  right: 1px;
  top: 0;
  width: 320px;
  transition: top 0.4s ease-out;
  z-index: $z-index-error-notifier;

  @include mobile {
    width: 100vw;
    left: 0;
  }

  .error-notifier__message {
    margin: 10px;
    flex-shrink: 0;
    transition: all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);

    @include mobile {
      margin: 0 0 5px 0;
    }
  }
}

.list-complete-enter,
.list-complete-leave-to {
  transform: translateY(-100vh);
}

.list-complete-leave-active {
  position: absolute;
  right: 0;
}
</style>
